import { render, staticRenderFns } from "./ManageUpdatesPage.vue?vue&type=template&id=4599b474&scoped=true"
import script from "./ManageUpdatesPage.vue?vue&type=script&lang=ts"
export * from "./ManageUpdatesPage.vue?vue&type=script&lang=ts"
import style0 from "./ManageUpdatesPage.vue?vue&type=style&index=0&id=4599b474&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4599b474",
  null
  
)

export default component.exports